<script setup lang="ts">
import { ProductExtended } from "@/../types/promos-types";
import { pushDataLayerClickHotelDetails } from "@/utils";
import { Ref } from "vue";

interface Props {
  product: ProductExtended;
  price: number;
  priceType: string;
  upliftInited: Ref<boolean>;
}

defineProps<Props>();

const clickFlexpay = (product: ProductExtended) => {
  pushDataLayerClickHotelDetails(product, "Flex Pay Link");
};
</script>
<template>
  <div
    class="promos-flex-pay"
    :data-up-price-type="priceType"
    :data-up-price-value="price"
    aria-haspopup="true"
    @click.prevent="clickFlexpay(product)"
  >
    <span v-if="upliftInited">
      <span>{{ $t("flexpay.from") }}</span>
      <button class="price-popover-link link">
        <span style="cursor: pointer">
          {{ $t("flexpay.from-prefix")
          }}<span data-up-from-currency-unit-major=""></span>
          <span>{{ $t("flexpay.per-month") }}</span>
          <span
            data-up-tooltip=""
            class="round-icon info"
            role="button"
            aria-haspopup="true"
            :aria-label="$t('flexpay.details')"
            tabindex="0"
          ></span>
        </span>
      </button>

      <span data-up-error="" style="display: none">
        {{ $t("flexpay.offer-not-available") }}
        <span data-up-tooltip=""> </span>
      </span>
    </span>
  </div>
</template>
<style lang="scss">
.promos-flex-pay {
  margin-top: 15px;
}
</style>
